import { useSelector } from "react-redux";
import { hasPermission } from "utils/permissions";

function usePermissions() {
  const permissions = useSelector((state) => state.auth.permissions);
  return {
    permissions,
    // null = still loading, so callers can avoid flashing "no access".
    isLoaded: Array.isArray(permissions),
    can: (required) => hasPermission(permissions, required),
  };
}

export default usePermissions;
